export enum FileKind {
  ATTACHMENT = 'attachment',
  TRANSCRIPTION = 'transcription',
  RECORDING = 'recording',
  INTERNAL_RECORDING = 'internal_recording',
  COMPLIANCE_ASSET = 'compliance_asset',
  LOGO_ASSET = 'logo_asset',
  DOCUMENT = 'document',
  FORM_TEMPLATE = 'form_template',
}

export enum FileStatus {
  REQUESTED = 'requested',
  UPLOADED = 'uploaded',
  FAILED = 'failed',
  ARCHIVED = 'archived',
}

export interface SessionFile {
  fileId: string
  accountId: string
  roomId: string
  userId: string
  fileName: string
  fileSize: number
  contentType: string
  sessionId: null
  kind: FileKind
  metadata: string
  status: FileStatus
}

export interface TranscriptionMetadata {
  enhanced?: boolean
  recordingFileId?: string
  transcriptionType: string
}

export interface FileDownloadLocation {
  location: string
}

export interface FileModel {
  fileId: string
  fileName: string
  fileSize: number
  userId: string
  contentType: string
  kind: FileKind
  metadata: string
  status: string
}
